// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3zAg6","choiceBoxes":"toolbarselects_choiceBoxes__1gM1R","simpleField":"toolbarselects_simpleField__1ZLMg"};